module.exports = __webpack_public_path__ + "img/organigram-fullscreen.f25d1fff.svg";